import { Controller } from 'stimulus';
import List from 'list.js';

function addToAttribute(attribute, newValue) {
  if (!attribute) return newValue;

  if (attribute.includes(newValue)) return attribute;

  return [attribute, newValue].join(' ');
}

const FUZZY_SEARCH = {
  fuzzySearch: {
    distance: 200,
    multiSearch: true,
  },
};

export default class extends Controller {
  static targets = ['search'];

  connect() { // eslint-disable-line class-methods-use-this
    this.checkForCommonBugs();
    this.initSearchTarget();
    this.list = new List(this.element, { ...this.options, ...FUZZY_SEARCH });
    if (this.sortOptions) {
      const { sortBy, orderBy } = this.sortOptions;
      this.list.sort(sortBy, orderBy);
    }
  }

  checkForCommonBugs() {
    if (!this.element.querySelector('.list')) console.log('.list class missing from rows parent', this.element);
    Array.from(this.element.querySelectorAll('[data-sort]')).forEach((el) => {
      if (!el.classList.contains('sort')) console.log('.sort class missing from sorting link', el);
    });
  }

  get options() {
    const elementOptions = this.element.dataset.options;
    return elementOptions ? JSON.parse(elementOptions) : {};
  }

  get sortOptions() {
    const elementSortOptions = this.element.dataset.sortOptions;
    return elementSortOptions ? JSON.parse(elementSortOptions) : null;
  }

  initSearchTarget() {
    if (!this.hasSearchTarget) return;
    const { dataset } = this.searchTarget;
    dataset.action = addToAttribute(dataset.action, `change->${this.identifier}#search`);
    dataset.action = addToAttribute(dataset.action, `keyup->${this.identifier}#search`);
  }

  search(evt) {
    if (this.hasSearchTarget) this.list.fuzzySearch(this.searchTarget.value);
    this.click(evt);
  }

  click(evt) {
    if (evt.key !== 'Enter') return;
    if (this.list.visibleItems.length === 0) return;

    const link = this.list.visibleItems[0].elm.querySelector('a');
    if (!link) return;

    link.click();
  }
}
